module.exports = __webpack_public_path__ + "img/ganymede.df2c7251.png";